import React, { useEffect, useRef, useState } from 'react';
import './EntryPage.css';

export const EntryPage = ({ onEnter }) => {

  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(max-width: 768px)').matches;
  });
  const [srcIndex, setSrcIndex] = useState(0);
  const [candidates, setCandidates] = useState(() => [
    '/resources/entrypagevid/pc_v_updated.mp4',
    '/resources/entrypagevid/pc v updated.mp4'
  ]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const handleChange = (e) => setIsMobile(e.matches);
    try {
      mediaQuery.addEventListener('change', handleChange);
    } catch (_) {
      // Safari fallback
      mediaQuery.addListener(handleChange);
    }
    return () => {
      try {
        mediaQuery.removeEventListener('change', handleChange);
      } catch (_) {
        mediaQuery.removeListener(handleChange);
      }
    };
  }, []);

  const handleClick = () => {
    onEnter();
  };

  useEffect(() => {
    const next = isMobile
      ? [
          '/resources/entrypagevid/mobilev.mp4',
          '/resources/entrypagevid/mobilev.mp4',
          // fallbacks
          '/resources/entrypagevid/pcv.mp4',
          '/resources/entrypagevid/pcv.mp4'
        ]
      : [
          '/resources/entrypagevid/pcv.mp4',
          '/resources/entrypagevid/pcv.mp4'
        ];
    setCandidates(next);
    setSrcIndex(0);
  }, [isMobile]);

  const videoSrc = encodeURI(candidates[srcIndex] || '');

  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    // Ensure browser reloads the new source and tries to play
    v.load();
    const tryPlay = () => {
      const p = v.play();
      if (p && typeof p.catch === 'function') {
        p.catch(() => {});
      }
    };
    if (v.readyState >= 2) {
      tryPlay();
    } else {
      v.oncanplay = () => {
        tryPlay();
        v.oncanplay = null;
      };
    }
  }, [videoSrc]);

  const handleError = () => {
    // Try the next candidate source if available
    if (srcIndex < candidates.length - 1) {
      setSrcIndex((i) => i + 1);
    }
  };

  const handleTouchStart = () => {
    // Hint iOS to allow playback before click navigation
    const v = videoRef.current;
    if (v && (v.paused || v.readyState < 2)) {
      const p = v.play();
      if (p && typeof p.catch === 'function') {
        p.catch(() => {});
      }
    }
  };

  return (
    <div
      className="entry-page"
      onClick={handleClick}
      onTouchStart={handleTouchStart}
      role="link"
      aria-label="Enter Home"
      style={{
        width: '100vw',
        height: '100vh',
        cursor: 'pointer',
        overflow: 'hidden'
      }}
    >
      <video
        ref={videoRef}
        src={videoSrc}
        autoPlay
        muted
        playsInline
        preload="auto"
        onError={handleError}
        onLoadedData={() => {
          const v = videoRef.current;
          if (v && v.paused) {
            const p = v.play();
            if (p && typeof p.catch === 'function') {
              p.catch(() => {});
            }
          }
        }}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          objectPosition: 'center center',
          display: 'block'
        }}
      />
    </div>
  );
};